<template>
    <div class="main main--hasHeader main--hasFooter">
        <div class="customContainer" style="margin-bottom: 2rem;">
            <div class="information-article">
                <ul class="information-article__list">
                    <li class="information-article__lists" v-for="(info, index) in lists" :key="index">
                        <router-link class="information-article__link" :to="'/information/' + info.id">
                        <p class="information-article__date" v-if="set_date_check(info.set_date_date_val)">{{ info.set_date_date_label }}</p>
                        <p class="information-article__description">{{ info.subject }}</p></router-link></li>
                </ul>
            </div>
            <!-- <bs-page-nav v-if="displayPager" :pager_key="'information'" @to_click_event="pageAction"></bs-page-nav> -->
        </div>
        <div class="customContainer" style="margin-bottom: 2rem;">
            <div class="members-menu__list">
                <ul v-if="false">
                    <li v-if="app_lang_type=='ja'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/members_guide_ja.23.8.24.pdf" target="_blank">
                            {{ word_chg('メンバーズガイド') }}
                        </a>
                    </li>
                    <li v-else-if="app_lang_type=='en'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/members_guide_en.23.8.24.pdf" target="_blank">
                            {{ word_chg('メンバーズガイド') }}
                        </a>
                    </li>

                    <li v-if="app_lang_type=='ja'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/facility_guide_ja.23.8.24.pdf" target="_blank">
                            {{ word_chg('ファシリティガイド') }}
                        </a>
                    </li>
                    <li v-else-if="app_lang_type=='en'">
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/facility_guide_en.23.8.24.pdf" target="_blank">
                            {{ word_chg('ファシリティガイド') }}
                        </a>
                    </li>
                    
                    <li v-if="app_lang_type=='ja'">
                    <a href="https://www1.ms-event.net/mgcweb/mgwfile/floormap_ja.pdf" target="_blank">
                        {{ word_chg('フロアマップ') }}
                    </a>
                    </li>
                    <li v-else-if="app_lang_type=='en'">
                    <a href="https://www1.ms-event.net/mgcweb/mgwfile/floormap_en.pdf" target="_blank">
                        {{ word_chg('フロアマップ') }}
                    </a>
                    </li>
                    <!-- <li>
                        <a href="https://www1.ms-event.net/mgcweb/mgwfile/members_guide.pdf" target="_blank">
                            コースガイド
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
// import BsPageTitle from '../molecules/BsPageTitle.vue'

import { mapState } from 'vuex'
// import BsPageNav from '../../molecules/BsPageNav.vue'
export default {
    name: 'BsDashBoardView',
    data: function () {
        return {

        }
    },
    props: {
        displayPager: {
            type: Boolean,
            default: true
        },
    },
    components: {
        // BsPageNav,
        // BsPageTitle,
    },
    methods: {
        loadLists () {
            // console.log('tag');
            const param = {};
            param['stat'] = [1];
            param['lang_type'] = this.app_lang_type;
            param['pageorder'] = 'sort';
            return this.$store.dispatch('fetchBasicLists', {data: param, target: 'information'})
                .catch(err => Promise.reject(err))
                .then(() => {
                    console.log('loard complete department');
                    console.log('this', this.$store.state.apidata.information);
                })
                .finally(() => {
                    console.log('finally', this.$store.state.apidata.information);
                })
        },
    },
    computed: {
        ...mapState({
            lists: state => state.apidata.information,
            set_lang: state => state.apidata.set_lang,
        }),
        set_date_check: function(){
            return function(value){
                if(
                    value != null 
                    && value != 'null' 
                    && value != '0000-00-00' 
                    && value != '' 
                    && value != false
                    && value != 'false' 
                ){
                    return true;
                }else{
                    return false;
                }
            }
        },
        app_lang_type: function (){
            // console.log('com')
            if(this.set_lang){
                return this.set_lang;
            }
            else{
                return this.$store.state.auth.app_lang_type;
            }
        },
    },

    created () {
        this.loadLists();
    },
}
</script>
